<template>
	<slide class="flex flex-col border text-left bg-blue-400 border-primary">
		<a :href="event.url" :title="event.title">
			<div class="py-3 px-10">
				<h2 class="mb-6">{{ event.title }}</h2>
				<div class="tw-block md:flex md:flex-row">
					<div class="mb-4 md:mb-0 md:w-1/4 flex-shrink-0"><img :alt="event.title" :src="event.image_url"></div>
					<div class="flex-shrink md:pl-4" v-html="event.short_description"></div>
				</div>
				<div class="border border-blue-500  bg-blue-200 rounded-md p-4 mt-6 shadow-inner">
					<h3 class="-mt-2">Nächste Veranstaltungsdaten</h3>
					<Eventdate v-for="eventdate in event.eventdates" :key="eventdate.id" :value="eventdate"></Eventdate>
				</div>
			</div>
		</a>
	</slide>
</template>

<script lang="ts" setup>
import 'vue3-carousel/dist/carousel.css'
import {Slide} from 'vue3-carousel'
import {CartEventInterface} from "@/js/interfaces/event"
import Eventdate from "@/js/components/checkout/summary/ticket/Eventdate.vue"

defineProps<{
	event: CartEventInterface
}>()
</script>

<style scoped>
a {
	color: unset
}
</style>
